<div>
    <br><br>
    <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-10 col-lg-8 mx-auto">
            <div class="card border-0 shadow rounded-3 my-9">
              <div class="card-header">
                <h4 style="text-align: center;"><b>{{ 'PROFILE.TITLE' | translate }}</b></h4>
              </div>
              <div class="card-body p-4 p-sm-5">
                <div class="row mb-3">
                    <div class="col-md-4 col-sm-12"></div>
                    <div class="col-md-4 col-sm-12">
                        <img style="border-radius: 125px;" src="assets/img/agent/agent-4.jpg" [alt]="'PROFILE.PHOTO_ALT' | translate"/>
                    </div>
                    <div class="col-md-4 col-sm-12"></div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6 col-sm-12">
                        <div class="input-group mb-4">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <nb-icon icon="person-outline" [options]="{ animation: { type: 'zoom' } }"></nb-icon>
                                    {{ 'PROFILE.FIRST_NAME' | translate }} :
                                </span>
                            </div> 
                            <input type="text" class="form-control" fullWidth
                                    [ngModel]="prenomuser" readonly>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="input-group mb-4">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <nb-icon icon="person-outline" [options]="{ animation: { type: 'zoom' } }"></nb-icon>
                                    {{ 'PROFILE.LAST_NAME' | translate }} :
                                </span>
                            </div> 
                            <input type="text" class="form-control" fullWidth
                                    [ngModel]="nomuser" readonly>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row mb-3">
                    <div class="col-md-6 col-sm-12">
                        <div class="input-group mb-4">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <nb-icon icon="calendar-outline" [options]="{ animation: { type: 'zoom' } }"></nb-icon>
                                    {{ 'PROFILE.BIRTH_DATE' | translate }} :
                                </span>
                            </div> 
                            <input type="text" class="form-control" fullWidth
                                    [ngModel]="datenaisuser" readonly>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="input-group mb-4">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <nb-icon icon="lock-outline" [options]="{ animation: { type: 'zoom' } }"></nb-icon>
                                    {{ 'PROFILE.GENDER' | translate }} :
                                </span>
                            </div> 
                            <input type="text" class="form-control" fullWidth
                                    [ngModel]="sexe === 'M' ? ('PROFILE.MALE' | translate) : ('PROFILE.FEMALE' | translate)" readonly>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row mb-3">
                    <div class="col-md-6 col-sm-12">
                        <div class="input-group mb-4">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <nb-icon icon="log-in-outline" [options]="{ animation: { type: 'zoom' } }"></nb-icon>
                                    {{ 'PROFILE.USERNAME' | translate }} :
                                </span>
                            </div> 
                            <input type="text" class="form-control" fullWidth
                                    [ngModel]="login" readonly>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="input-group mb-4">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <nb-icon icon="phone-call-outline" [options]="{ animation: { type: 'zoom' } }"></nb-icon>
                                    {{ 'PROFILE.PHONE' | translate }} :
                                </span>
                            </div> 
                            <input type="text" class="form-control" fullWidth
                                    [ngModel]="phonenumber" readonly>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row mb-3">
                    <div class="col-md-6 col-sm-12">
                        <div class="input-group mb-4">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <nb-icon icon="email-outline" [options]="{ animation: { type: 'zoom' } }"></nb-icon>
                                    {{ 'PROFILE.EMAIL' | translate }} :
                                </span>
                            </div> 
                            <input type="email" class="form-control" fullWidth
                                    [ngModel]="emailuser" readonly>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="input-group mb-4">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <nb-icon icon="lock-outline" [options]="{ animation: { type: 'zoom' } }"></nb-icon>
                                    {{ 'PROFILE.PASSWORD' | translate }} :
                                </span>
                            </div> 
                            <input type="password" class="form-control" fullWidth
                                    [ngModel]="passworduser" readonly>
                        </div>
                    </div>
                </div>
                <hr>
              </div>
            </div>
          </div>
        </div>
    </div>
    <br><br>
</div>


